import React from 'react';
import Unread from './Unread';
import ReadFailed from './ReadFailed';
import { READING } from '../domain/reading';
import s from './Card.module.css';

// A titled panel. `action` is the control that belongs to the panel's heading —
// an "+ Add" button, usually — kept as a slot so the card stays presentational.
//
// `subtitle` is a quieter second line under the title, for a fact that
// qualifies everything in the card rather than being one row of it, as MMS
// puts a student's time zone (`Timezone: (UTC-08:00) Pacific Time (US &
// Canada)`) under "Student Details".
export default function Card({ title, subtitle = null, action, children }) {
  return (
    <div className={s.card}>
      {title ? (
        <div className={s.head}>
          <div className={s.titleBlock}>
            <div className={s.title}>{title}</div>
            {subtitle ? <div className={s.subtitle}>{subtitle}</div> : null}
          </div>
          {action}
        </div>
      ) : null}
      {children}
    </div>
  );
}

// A card whose entire content is an explanation of why it is empty.
//
// `reading` is required, as `EmptyState`'s is (#629, #637): while the list it
// explains is unread the card is the loading state, not "nothing yet".
export function EmptyCard({ reading, children }) {
  if (reading === READING.unread) return <Unread />;
  if (reading === READING.failed) return <Card><ReadFailed /></Card>;
  return <Card><div className={s.muted}>{children}</div></Card>;
}
